import { IOrderProduct } from '@/models/orders.model';
import { AmountSelectMeta } from '@/types';

export const updateProductsList = (data: { id: string; quantity: number }[], value: number, product: IOrderProduct) => {
  const targetItem = data.find((el) => el.id === product.id);

  if (!targetItem) return [...data, { id: product.id, quantity: value }];

  return data.map((el) => {
    if (el.id === product.id) {
      return { ...el, quantity: value };
    }
    return el;
  });
};

export const updateProductsListWithMeta = (
  data: { id: string; quantity: number }[],
  metaType: AmountSelectMeta,
  product: IOrderProduct,
) => {
  const targetItem = data.find((el) => el.id === product.id);

  if (!targetItem) return [...data, { id: product.id, quantity: 1 }];

  return data.map((el) => {
    if (el.id === product.id) {
      return { ...el, quantity: el.quantity + (metaType === AmountSelectMeta.DOWN ? -1 : 1) };
    }

    return el;
  });
};
